import { render } from "./slide1.vue?vue&type=template&id=17731a60&scoped=true"
import script from "./slide1.vue?vue&type=script&lang=js"
export * from "./slide1.vue?vue&type=script&lang=js"

import "./slide1.vue?vue&type=style&index=0&id=17731a60&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17731a60"]])

export default __exports__